<template>
  <div class="practicalActivity">
    <!-- 操作栏容器 -->
    <div class="practicalActivity-info-operation-container">
      <div class="practicalActivity-info-search-container">
        <!-- 搜索框 -->
        <search class="search" :placeholder="activityNamePlaceholder" @search="activityNameSearch" />
        <!-- <el-cascader
          class="student-search"
          v-model="className"
          placeholder="选择班级"
          :props="classProps"
          :options="classSelect"
          @change="changeHandle"
        ></el-cascader> -->
        <!-- <el-date-picker
          style="width: 100px; margin-left: 20px"
          v-model="searchInfo.schoolYear"
          type="year"
          placeholder="学年"
          @change="schoolYearChangeHandle"
        >
        </el-date-picker> -->
        <year-range-picker style="width: 250px;margin-left: 10px" v-model="searchInfo.schoolYear"
          @change="schoolYearChangeHandle" />
        <el-select style="width: 105px; margin-left: 20px" v-model="searchInfo.semester" placeholder="学期" clearable
          @change="semesterChangeHandle">
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </div>
      <div class="practicalActivity-info-button-container">
        <button class="button add-practicalActivity" @click="addpracticalActivityDialogShow"
          v-hasPermi="'sc:practicalactivity:add'">
          <i class="iconfont icon-add"></i>新增活动
        </button>
        <!-- 批量删除 -->
        <button class="button delete-practicalActivity" @click="deleteClick" v-hasPermi="'sc:practicalactivity:delete'">
          <i class="iconfont icon-delete" />批量删除
        </button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="practicalActivity-info-table-container" v-bitmap="getListResult">
      <practicalActivityList class="practicalActivity-list" v-show="total" :semesterOptions="semesterOptions"
        :practicalActivityList="practicalActivityList" @multipleDelete="multipleDelete" />
    </div>
    <!-- 分页容器 -->
    <div class="practicalActivity-info-pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" />
    </div>
    <practicalActivityAdd :classSelect="classSelect"
      :isAddPracticalActivityDialogShow.sync="isAddPracticalActivityDialogShow"
      v-show="isAddPracticalActivityDialogShow" @formSubmit="formSubmit" :semesterOptions="semesterOptions"
      :schoolYear="searchInfo.schoolYear" :semester="searchInfo.semester" />
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
import pagination from "@/components/pagination/pagination";
import practicalActivityList from "./components//practicalActivity-list/practicalActivityList.vue";
import practicalActivityAdd from "./components/practicalActivity-add/practicalActivityAdd.vue";
export default {
  components: {
    search,
    pagination,
    practicalActivityList,
    practicalActivityAdd,
  },
  data() {
    return {
      activityNamePlaceholder: "请输入活动名称",
      getListResult: "nullData",
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      // 班级年级数据
      classSelectList: [],
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 搜索条件
      searchInfo: {
        activityName: "",
        schoolYear: "", // 学年
        semester: "", // 学期
      },
      practicalActivityList: [],
      deleteList: [], // 活动批量删除列表
      isAddPracticalActivityDialogShow: false,
      semesterOptions: [],
    };
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.getSchoolDetails();
    this.getDictType();
  },
  methods: {
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        let schoolInfo = res.data;
        this.searchInfo.semester = schoolInfo.semester;
        this.searchInfo.schoolYear = schoolInfo.schoolYear;
        // 先获取学年学期，再获取获奖情况
        this.getPracticalActivityList();
      });
    },
    // 获取学期类型选择列表数据
    getDictType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    schoolYearChangeHandle(e) {
      // console.log(e);
      // this.searchInfo.schoolYear = e ? "" + e.getFullYear() : "";
      this.refresh();
    },
    semesterChangeHandle(e) {
      this.searchInfo.semester = e;
      this.refresh();
    },
    formSubmit(data) {
      let { recordTime, activityName, activityDate, schoolYear, semester } = data;
      this.post(this.$url.addPracticalActivity, {
        activityName,
        startTime: activityDate[0], //活动开始时间 可选
        endTime: activityDate[1], //活动结束时间 可选
        schoolYear,
        semester,
        recordStartTime: recordTime[0],
        recordEndTime: recordTime[1]
      }).then((res) => {
        // console.log(res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success("添加成功");
        this.refresh();
      });
    },
    activityNameSearch(e) {
      this.searchInfo.activityName = e;
      // 刷新列表
      this.refresh();
    },
    // 显示添加弹出框
    addpracticalActivityDialogShow() {
      this.isAddPracticalActivityDialogShow = true;
    },
    // 选择班级
    changeHandle(e) {
      // console.log("选中的班级==>", e);
      this.searchInfo.gradeId = e[0].gradeId;
      this.searchInfo.classId = e[1].classId;
    },
    multipleDelete(res) {
      this.deleteList = res;
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的活动");
      }
      this.$confirm("是否删除选中的活动?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.delPracticalActivity + "/" + this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              }
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.practicalActivityList = [];
      this.isAddPracticalActivityDialogShow = false;
      this.getPracticalActivityList();
    },
    // 获取活动获奖列表
    getPracticalActivityList() {
      let { activityName, schoolYear, semester } = this.searchInfo;
      let data = {
        // schoolId: this.user.schoolId,
        activityName, //活动名称
        schoolYear,
        semester,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      // this.getListResult = "loading";
      this.get(this.$url.getPracticalActivityList, data).then((res) => {
        // console.log("获取实践活动列表==>", res);
        this.total = res.total;
        if (this.total <= 0) return (this.getListResult = "nullData");
        this.getListResult = "success";
        this.practicalActivityList = res.rows;
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getPracticalActivityList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getPracticalActivityList();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.post(this.$url.selectSchoolAndGradeAndClassListPC, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          this.classSelectList = res.rows;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          // this.$message.error("获取班级列表失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./practicalActivity.scss";
</style>
